import { render } from "./DashbordPage.vue?vue&type=template&id=3add0b74&scoped=true"
import script from "./DashbordPage.vue?vue&type=script&lang=js"
export * from "./DashbordPage.vue?vue&type=script&lang=js"

import "./DashbordPage.vue?vue&type=style&index=0&id=3add0b74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3add0b74"]])

export default __exports__